<template>
    <li class="nav-item ">
      <router-link
        :to="link.path"
        @click.native="linkClick"
        class="nav-link"
        :target="link.target"
        :href="link.path"
      >
        <template>
          <div class="btnOutline">
            <img :src="link.icon" :title="link.title" class="sidebarImage">
            <span class="nav-link-text">{{ link.name }}</span>
          </div>
        </template>
      </router-link>
    </li>
</template>
<script>
  export default {
    name: 'sidebar-item',
    props: {
      link: {
        type: Object,
        default: () => {
          return {
            name: '',
            path: '',
            children: []
          };
        },
        description:
          'Sidebar link. Can contain name, path, icon and other attributes. See examples for more info'
      }
    },
    inject: {
      autoClose: {
        default: true
      }
    },
    data() {
      return {
        children: [],
        collapsed: true
      };
    },
    methods: {
      linkClick() {
        if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
        ) {
          this.$sidebar.displaySidebar(false);
        }
      }
    }
  };
</script>
<style>
.sidebarImage {
  width: 50px;
  height: 50px;
  
}
.btnOutline {
  /* outline: solid;
  outline-width: 1px;
  outline-color: gray;
  box-shadow: 2px 2px gray; */

  border-radius: 2pt;
  padding: 2px;
  box-shadow: 2px 2px 0 1pt grey;
  outline: none;
  transition: .1s;
}
</style>
